import React, { useState } from "react";
import Select from "react-select";
import { extractParameterValues } from "../../../utils/helperFuctions";

const InputMultiSelect = ({
  label,
  name,
  id,
  placeholder,
  options,
  handleChange,
  defaultValue,
  disabled,
  required,
}) => {
  const [selectedOptions, setSelectedOptions] = useState(() => {
    return (
      defaultValue?.map((e) => {
        return {
          value: typeof e === "object" ? e.currency_id?.id : e.id,
          label: typeof e === "object" ? e.currency_id?.code : e.code,
        };
      }) ?? []
    );
  });

  const inputChange = (selectedValues) => {
    const _e = {
      target: {
        name: name,
        value: extractParameterValues(selectedValues, "value"),
      },
    };
    setSelectedOptions(selectedValues);
    handleChange(_e);
  };

  return (
    <div>
      <label
        htmlFor={name}
        className="block text-sm font-medium leading-6 text-gray-900"
      >
        {label}
        {required ? "*" : ""}
      </label>
      <div className="relative mt-2 rounded-md shadow-sm">
        <Select
          isMulti
          options={
            Array.isArray(options)
              ? options.map((i) => {
                  return { value: i.id, label: i.name };
                })
              : options
          }
          className="basic-multi-select"
          classNamePrefix="select"
          value={selectedOptions}
          onChange={inputChange}
          placeholder={placeholder ?? "Select an Option"}
          name={name}
          id={id}
          isDisabled={disabled ?? false}
        />
      </div>
    </div>
  );
};

export default InputMultiSelect;
